import styled, { css } from 'styled-components';

import { SCROLL_BAR_WIDTH } from 'constants/sizes';

export const Container = styled.div`
  height: 96px;
  flex-shrink: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  top: 0;
  left: 0;
  right: ${SCROLL_BAR_WIDTH};
  position: absolute;

  z-index: 100;

  background: rgba(7, 8, 6, 0.8);
  backdrop-filter: blur(10px);

  ${({ theme }) => css`
    padding: 0 ${theme.sizes.padding.biggest};
  `}
`;
